import { styled } from '@linaria/react';
import theme from '../../theme';

export const AdminHeader = styled.div`
    margin-bottom: 3rem;
    text-align: center;

    h1 {
        color: #2c3e50;
        font-size: 2.5rem;
        margin-bottom: 0.5rem;
    }

    p {
        color: #7f8c8d;
        font-size: 1.1rem;
        margin: 0;
    }
`;

export const TabContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    margin-top: 0.5rem;
`;

export const TabListWrapper = styled.div`
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    /* Fill available height from parent ListDetailLayout */
    height: 100%;
    max-height: 100%;

    .loading-state,
    .error-state {
        padding: 2rem;
        text-align: center;

        i {
            font-size: 2rem;
            margin-bottom: 1rem;
        }

        p {
            margin: 0;
            font-size: 0.875rem;
        }
    }

    .loading-state {
        color: #6c757d;

        i {
            color: #007bff;
        }
    }

    .error-state {
        color: #dc3545;
    }

    .empty-state {
        padding: 2rem;
        text-align: center;
        color: #6c757d;

        i {
            font-size: 2rem;
            margin-bottom: 1rem;
            display: block;
        }

        p {
            margin: 0;
            font-size: 0.875rem;
        }
    }

    .table-container {
        flex: 1;
        overflow-y: auto;
        min-height: 0;

        /* Custom scrollbar styling */
        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 4px;

            &:hover {
                background: #a1a1a1;
            }
        }
    }

    .data-table {
        width: 100%;
        border-collapse: collapse;
        background: white;
        font-size: 0.9rem;

        thead {
            position: sticky;
            top: 0;
            z-index: 1;
        }

        th {
            background-color: ${theme.colors.background.tableHeader};
            color: #495057;
            font-weight: 600;
            padding: 0.875rem 1rem;
            text-align: left;
            border-bottom: 2px solid #dee2e6;
            white-space: nowrap;
            font-size: 0.85rem;
            text-transform: uppercase;
            letter-spacing: 0.025em;
        }

        td {
            padding: 0.75rem 1rem;
            border-bottom: 1px solid #f1f3f4;
            vertical-align: middle;
        }

        .table-row {
            cursor: pointer;
            transition: background-color 0.2s ease;

            &:hover {
                background-color: #f8f9fa;
            }

            &.selected {
                background-color: #e3f2fd;
            }

            &.inactive {
                opacity: 0.6;
            }
        }
    }
`;

export const TabContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    gap: 1rem;

    /* Details panel takes 65%, products list takes 35% */
    > *:first-child {
        flex: 0 0 65%;
        min-height: 0;
        overflow: hidden;
    }

    > *:nth-child(2) {
        flex: 0 0 calc(35% - 1rem);
        min-height: 0;
        overflow: hidden;
    }
`;

export const ListDetailLayout = styled.div`
    display: grid;
    grid-template-columns: 1.25fr 2fr;
    gap: 1rem;
    flex: 1;
    min-height: 0;
    height: 100%;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 0.5rem;
        height: auto;
        min-height: unset;
    }
`;

export const ListPanel = styled.div`
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    /* Fill available height from parent ListDetailLayout */
    height: 100%;
    max-height: 100%;

    .section-header {
        background: #f8f9fa;
        padding: 1rem;
        border-bottom: 1px solid #e9ecef;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;

        h3 {
            margin: 0;
            color: #495057;
            font-size: 1.1rem;
        }

        .btn {
            background: #007bff;
            color: white;
            border: none;
            padding: 0.5rem 1rem;
            border-radius: 4px;
            cursor: pointer;
            font-size: 0.875rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            transition: background 0.2s ease;

            &:hover {
                background: #0056b3;
            }

            &.btn-primary {
                background: #007bff;

                &:hover {
                    background: #0056b3;
                }
            }
        }
    }

    .loading-state,
    .error-state {
        padding: 2rem;
        text-align: center;

        i {
            font-size: 2rem;
            margin-bottom: 1rem;
        }

        p {
            margin: 0;
            font-size: 0.875rem;
        }
    }

    .loading-state {
        color: #6c757d;

        i {
            color: #007bff;
        }
    }

    .error-state {
        color: #dc3545;
    }

    .empty-state {
        padding: 2rem;
        text-align: center;
        color: #6c757d;

        i {
            font-size: 2rem;
            margin-bottom: 1rem;
            display: block;
        }

        p {
            margin: 0;
            font-size: 0.875rem;
        }
    }

    .table-container {
        flex: 1;
        overflow-y: auto;
        min-height: 0;

        /* Custom scrollbar styling */
        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 4px;

            &:hover {
                background: #a1a1a1;
            }
        }
    }

    .data-table {
        width: 100%;
        border-collapse: collapse;
        background: white;
        font-size: 0.9rem;

        thead {
            position: sticky;
            top: 0;
            z-index: 1;
        }

        th {
            background-color: rgb(238 238 238);
            color: #495057;
            font-weight: 600;
            padding: 0.875rem 1rem;
            text-align: left;
            border-bottom: 2px solid #dee2e6;
            white-space: nowrap;
            font-size: 0.85rem;
            text-transform: uppercase;
            letter-spacing: 0.025em;
        }

        td {
            padding: 0.75rem 1rem;
            border-bottom: 1px solid #f1f3f4;
            vertical-align: middle;
        }

        .table-row {
            cursor: pointer;
            transition: background-color 0.2s ease;

            &:hover {
                background-color: #f8f9fa;
            }

            &.selected {
                background-color: #e3f2fd;
            }

            &.inactive {
                opacity: 0.6;
            }

            &.unavailable {
                opacity: 0.6;
                font-style: italic;
            }
        }
    }

    .items-list {
        flex: 1;
        overflow-y: auto;
        min-height: 0;

        /* Custom scrollbar styling */
        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 4px;

            &:hover {
                background: #a1a1a1;
            }
        }

        .list-item {
            padding: 1rem;
            border-bottom: 1px solid #f1f3f4;
            cursor: pointer;
            transition: background-color 0.2s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &:last-child {
                border-bottom: none;
            }

            &:hover {
                background-color: #f8f9fa;
            }

            &.active {
                background-color: #e3f2fd;
                border-left: 4px solid #007bff;
            }

            .item-info {
                flex: 1;

                .item-title {
                    margin: 0 0 0.25rem 0;
                    color: #333;
                    font-size: 0.9rem;
                    font-weight: 600;
                }

                .item-subtitle {
                    margin: 0;
                    color: #666;
                    font-size: 0.8rem;
                }
            }

            .item-meta {
                .item-id {
                    font-size: 0.75rem;
                    color: #999;
                }
            }
        }
    }
`;

export const AdminContent = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh - ${theme.constants.pageHeaderHeight} - ${theme.constants.pageHeaderMargin} - ${theme.constants.adminContentPadding} - ${theme.constants.adminContentPadding});
    padding: ${theme.constants.adminContentPadding};
    overflow: hidden;

    .master-detail-layout {
        display: grid;
        grid-template-columns: 1.25fr 2fr;
        gap: 1rem;
        margin-top: 1rem;

        @media (max-width: 768px) {
            grid-template-columns: 1fr;
            gap: 0.5rem;
        }
    }

    .master-panel {
        background: white;
        border: 1px solid #e9ecef;
        border-radius: 4px;
        overflow: hidden;

        .section-header {
            background: #f8f9fa;
            padding: 1rem;
            border-bottom: 1px solid #e9ecef;
            display: flex;
            justify-content: space-between;
            align-items: center;

            h3 {
                margin: 0;
                color: #495057;
                font-size: 1.1rem;
            }

            .btn {
                background: #007bff;
                color: white;
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 4px;
                cursor: pointer;
                font-size: 0.875rem;
                display: flex;
                align-items: center;
                gap: 0.5rem;
                transition: background 0.2s ease;

                &:hover {
                    background: #0056b3;
                }

                &.btn-primary {
                    background: #007bff;

                    &:hover {
                        background: #0056b3;
                    }
                }
            }
        }

        .loading-state,
        .error-state {
            padding: 2rem;
            text-align: center;

            i {
                font-size: 2rem;
                margin-bottom: 1rem;
            }

            p {
                margin: 0;
                font-size: 0.875rem;
            }
        }

        .loading-state {
            color: #6c757d;

            i {
                color: #007bff;
            }
        }

        .error-state {
            color: #dc3545;
        }

        .items-list {
            max-height: 400px;
            overflow-y: auto;

            .list-item {
                padding: 1rem;
                border-bottom: 1px solid #f1f3f4;
                cursor: pointer;
                transition: background-color 0.2s ease;
                display: flex;
                justify-content: space-between;
                align-items: center;

                &:last-child {
                    border-bottom: none;
                }

                &:hover {
                    background-color: #f8f9fa;
                }

                &.active {
                    background-color: #e3f2fd;
                    border-left: 4px solid #007bff;
                }

                .item-info {
                    flex: 1;

                    .item-title {
                        margin: 0 0 0.25rem 0;
                        color: #333;
                        font-size: 0.9rem;
                        font-weight: 600;
                    }

                    .item-subtitle {
                        margin: 0;
                        color: #666;
                        font-size: 0.8rem;
                    }
                }

                .item-meta {
                    .item-id {
                        font-size: 0.75rem;
                        color: #999;
                    }
                }
            }
        }
    }

    .table-container {
        overflow-x: auto;
        border-radius: 4px;
        border: 1px solid #e9ecef;
    }

    .data-table {
        width: 100%;
        border-collapse: collapse;
        background: white;
        font-size: 0.9rem;

        th {
            background-color: ${theme.colors.background.tableHeader};
            color: #495057;
            font-weight: 600;
            padding: 0.875rem 1rem;
            text-align: left;
            border-bottom: 2px solid #dee2e6;
            white-space: nowrap;
            font-size: 0.85rem;
            text-transform: uppercase;
            letter-spacing: 0.025em;
        }

        tbody tr {
            cursor: pointer;
            transition: all 0.2s ease;
            
            /* Alternating row colors */
            &:nth-child(even) {
                background-color: #f8f9fa;
            }
            
            &:nth-child(odd) {
                background-color: white;
            }

            /* Hover effect */
            &:hover {
                background-color: #e3f2fd !important;
                transform: translateY(-1px);
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            }

            /* Selected state */
            &.selected {
                background-color: #e3f2fd !important;
                border-left: 4px solid #007bff;
                
                td {
                    color: #1565c0;
                    font-weight: 500;
                }
                
                .title-cell,
                .type-cell {
                    color: #007bff;
                    font-weight: 600;
                }
            }
        }

        td {
            padding: 0.75rem 1rem;
            border-bottom: 1px solid #dee2e6;
            vertical-align: top;
            color: #495057;
            line-height: 1.4;
            transition: all 0.2s ease;
        }

        tr:last-child td {
            border-bottom: none;
        }

        .title-cell {
            font-weight: 500;
            color: #495057;
        }

        .type-cell {
            font-weight: 500;
            color: #007bff;
            white-space: nowrap;
        }

        .description-cell {
            max-width: 400px;
            line-height: 1.4;
            color: #6c757d;
        }

        .status-cell {
            text-align: center;
            width: 100px;
        }
    }

    .empty-state {
        padding: 3rem 2rem;
        text-align: center;
        color: #6c757d;

        i {
            font-size: 3rem;
            margin-bottom: 1rem;
            color: #adb5bd;
        }

        p {
            margin: 0;
            font-size: 1rem;
        }
    }

    .text-muted {
        color: #999;
    }

`;

export const EditActionsBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 1rem;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    gap: 0.5rem;

    > div {
        display: flex;
        gap: 0.5rem;
    }

    .btn-save,
    .btn-cancel,
    .btn-add-new {
        border: none;
        padding: 0.5rem 1rem;
        border-radius: 4px;
        font-size: 0.875rem;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        transition: all 0.2s ease;
        font-weight: 500;

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }

        i {
            font-size: 0.875rem;
        }
    }

    .btn-save {
        background: #28a745;
        color: white;

        &:hover:not(:disabled) {
            background: #218838;
        }
    }

    .btn-cancel {
        background: #6c757d;
        color: white;

        &:hover:not(:disabled) {
            background: #5a6268;
        }
    }

    .btn-add-new {
        background: #007bff;
        color: white;

        &:hover:not(:disabled) {
            background: #0056b3;
        }
    }
`;

export const SubNavBar = styled.div`
    display: flex;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;

    .nav-btn {
        border: none;
        padding: 0.5rem 1rem;
        border-radius: 4px;
        font-size: 0.875rem;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        transition: all 0.2s ease;
        font-weight: 500;
        background: #6c757d;
        color: white;

        &:hover {
            background: #5a6268;
        }

        i {
            font-size: 0.875rem;
        }
    }
`;

export const DetailPanel = styled.div`
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;

    .detail-content {
        padding: 1.5rem;
        flex: 1;
        overflow-y: auto;
        min-height: 0;

        /* Custom scrollbar styling */
        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 4px;

            &:hover {
                background: #a1a1a1;
            }
        }
    }

    .detail-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1.5rem;
        padding-bottom: 0.5rem;
        border-bottom: 1px solid #e9ecef;

        h3 {
            margin: 0;
            color: #495057;
            font-size: 1.25rem;
            font-weight: 600;
        }

        .header-right {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 0.5rem;
        }

        .last-updated {
            font-size: 0.75rem;
            color: #6c757d;
            font-weight: normal;
            text-align: right;
        }

        .header-actions {
            display: flex;
            align-items: center;
            gap: 0.75rem;
        }

        .category-badge {
            display: inline-block;
            padding: 0.25rem 0.75rem;
            border-radius: 4px;
            font-size: 0.75rem;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.025em;
            background: #e3f2fd;
            color: #1565c0;
            
            &.emergency {
                background: #ffebee;
                color: #c62828;
                border: 1px solid #ffcdd2;
            }
        }

        .edit-btn {
            background: transparent;
            border: none;
            color: #007bff;
            cursor: pointer;
            padding: 0.5rem;
            border-radius: 4px;
            font-size: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s ease;

            &:hover {
                background: #e7f3ff;
                color: #0056b3;
            }

            &:active {
                transform: scale(0.95);
            }

            i {
                pointer-events: none;
            }
        }

        .edit-actions {
            display: flex;
            gap: 0.5rem;
        }

        .btn-save,
        .btn-cancel {
            border: none;
            padding: 0.4rem 0.8rem;
            border-radius: 4px;
            font-size: 0.85rem;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 0.4rem;
            transition: all 0.2s ease;
            font-weight: 500;

            &:disabled {
                opacity: 0.6;
                cursor: not-allowed;
            }

            i {
                font-size: 0.85rem;
            }
        }

        .btn-save {
            background: #28a745;
            color: white;

            &:hover:not(:disabled) {
                background: #218838;
            }
        }

        .btn-cancel {
            background: #6c757d;
            color: white;

            &:hover:not(:disabled) {
                background: #5a6268;
            }
        }
    }

    .error-alert {
        margin: 1rem 0;
        padding: 0.75rem;
        background: #f8d7da;
        border: 1px solid #f5c6cb;
        border-radius: 4px;
        color: #721c24;
        display: flex;
        align-items: center;
        gap: 0.5rem;

        i {
            font-size: 1rem;
        }
    }

    .detail-body {
        .detail-section {
            margin-bottom: 1.5rem;

            &:last-child {
                margin-bottom: 0;
            }

            h4 {
                margin: 0 0 0.75rem 0;
                color: #495057;
                font-size: 1rem;
                font-weight: 600;
            }

            p {
                margin: 0;
                color: #6c757d;
                line-height: 1.5;
            }

            .description-content {
                min-height: 500px;
                max-height: 500px;
                overflow-y: auto;
                padding-right: 8px;
                border: 1px solid #e9ecef;
                border-radius: 4px;
                padding: 12px;
                background-color: #f8f9fa;
                white-space: pre-line;
                
                &::-webkit-scrollbar {
                    width: 6px;
                }
                
                &::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 3px;
                }
                
                &::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 3px;
                    
                    &:hover {
                        background: #a8a8a8;
                    }
                }
            }

            .detail-grid {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                gap: 0.5rem;
                margin-bottom: 1rem;
                
                .detail-item {
                    label {
                        display: block;
                        font-size: 0.7rem;
                        font-weight: 600;
                        text-transform: uppercase;
                        letter-spacing: 0.025em;
                        color: #adb5bd;
                        margin-bottom: 0.2rem;
                    }

                    span {
                        display: block;
                        color: #495057;
                        font-weight: 500;
                        font-size: 0.875rem;
                    }

                    .edit-select {
                        width: 100%;
                        padding: 0.4rem 0.5rem;
                        border: 1px solid #ced4da;
                        border-radius: 4px;
                        background: #fff;
                        color: #495057;
                        font-size: 0.875rem;
                        font-weight: 500;
                        cursor: pointer;
                        transition: border-color 0.2s ease;

                        &:focus {
                            outline: none;
                            border-color: #007bff;
                            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                        }

                        &:hover {
                            border-color: #adb5bd;
                        }
                    }
                }
            }
        }
    }

    .detail-placeholder {
        padding: 3rem 2rem;
        text-align: center;
        color: #6c757d;

        i {
            font-size: 3rem;
            margin-bottom: 1rem;
            color: #adb5bd;
        }

        h3 {
            margin: 0 0 0.5rem 0;
            color: #495057;
            font-size: 1.25rem;
        }

        p {
            margin: 0;
            color: #6c757d;
            font-size: 0.875rem;
        }
    }

    .products-list {
        margin-top: 1rem;
        
        .products-table {
            border: 1px solid #e9ecef;
            border-radius: 4px;
            overflow: hidden;
            
            .products-header {
                display: grid;
                grid-template-columns: 40px 1fr 1fr 1fr 120px;
                background-color: #f8f9fa;
                border-bottom: 1px solid #dee2e6;
                
                .product-header-cell {
                    padding: 0.75rem 1rem;
                    font-weight: 600;
                    color: #495057;
                    font-size: 0.85rem;
                    text-transform: uppercase;
                    letter-spacing: 0.025em;
                    border-right: 1px solid #dee2e6;
                    
                    &:last-child {
                        border-right: none;
                    }
                    
                    &.icon-header {
                        text-align: center;
                    }
                }
            }
            
            .product-row {
                display: grid;
                grid-template-columns: 40px 1fr 1fr 1fr 120px;
                cursor: pointer;
                transition: all 0.2s ease;
                border-bottom: 1px solid #f1f3f4;
                
                &:nth-child(even) {
                    background-color: #f8f9fa;
                }
                
                &:nth-child(odd) {
                    background-color: white;
                }
                
                &:hover {
                    background-color: #e3f2fd !important;
                    transform: translateY(-1px);
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                }
                
                &:last-child {
                    border-bottom: none;
                }
                
                .product-cell {
                    padding: 0.75rem 1rem;
                    border-right: 1px solid #f1f3f4;
                    display: flex;
                    align-items: center;
                    font-size: 0.9rem;
                    
                    &:last-child {
                        border-right: none;
                    }
                    
                    &.icon-cell {
                        justify-content: center;
                        
                        .marpol-icon {
                            width: 24px;
                            height: 24px;
                        }
                    }
                    
                    &.product-name-cell {
                        .product-name {
                            font-weight: 500;
                            color: #007bff;
                        }
                    }
                }
            }
        }
    }
`;

export const InlineFieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const InlineFieldRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
`;

export const InlineFieldLabel = styled.label`
    font-size: 0.875rem;
    font-weight: 600;
    color: #495057;
    min-width: 140px;
`;

export const InlineFieldValue = styled.span`
    color: #495057;
    font-weight: 500;
    font-size: 0.875rem;
`;

export const TwoColumnLayout = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const HazardIcon = styled.img`
    width: 32px;
    height: auto;
    margin-right: 0.5rem;
    vertical-align: middle;
`;

export const HazardIconSelector = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 0.5rem 0;
`;

export const HazardIconOption = styled.img<{ $isSelected?: boolean }>`
    width: 35px;
    height: auto;
    cursor: pointer;
    transition: all 0.2s ease;
    border-bottom: ${props => props.$isSelected ? '2px solid #007bff' : '2px solid transparent'};
    padding-bottom: ${props => props.$isSelected ? '5px' : '0'};

    &:hover {
        transform: scale(1.1);
        border-bottom-color: #ccc;
    }
`;

export const FileUploadContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const FileUploadRow = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;
`;

export const HiddenFileInput = styled.input`
    display: none;
`;

export const UploadButton = styled.button`
    background: #28a745;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover:not(:disabled) {
        background: #218838;
    }

    &:disabled {
        background: #6c757d;
        cursor: not-allowed;
        opacity: 0.6;
    }

    i {
        font-size: 0.875rem;
    }
`;

export const FileLink = styled.a`
    color: ${theme.colors.text.fileLink};
    font-weight: ${theme.fontWeights.fileLink};
    text-decoration: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    transition: color 0.2s ease;

    &:hover {
        color: ${theme.colors.text.fileLinkHover};
        text-decoration: underline;
    }

    i {
        font-size: 1rem;
        color: #dc3545;
    }
`;

export const SuccessMessage = styled.div`
    color: #28a745;
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    i {
        font-size: 1rem;
    }
`;

export const ErrorMessage = styled.div`
    color: #dc3545;
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    i {
        font-size: 1rem;
    }
`;
